import { useState, useCallback } from 'react';
import quarkusApi from '../../../api/quarkusApi';

export function useDeleteRoom() {
  const [isDeleting, setDeleting] = useState(false);

  const remove = useCallback((roomId) => {
    setDeleting(true);
    return quarkusApi
      .delete(`/rooms/${roomId}`, {
        headers: { Authorization: sessionStorage.getItem('token') },
      })
      .finally(() => setDeleting(false));
  }, []);

  return { remove, isDeleting };
}
